<template>
  <div class='smallScroll'>
    <div ref="infoWrapper" class="wrapper">
      <div>{{courseData.kcmc}}</div>
      <div>{{courseData.skrq}}</div>
      <div>{{courseData.skdd}}</div>
    </div>
  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //通信总线
  import Bus from 'common/js/bus.js'

  const SCROLL_DURING = 2000

  export default {
    name: "smallScroll",
    data() {
      return {
        heiList: [],
        currShowIdx: 0
      }
    },
    props: {
      courseData: {
        type: Object,
        default() {
          return {
            "dsz": "0",
            "jsj": "8",
            "jsxm": "杨丽霞",
            "kcmc": "有机化学",
            "qsj": "7",
            "skdd": "基础化学实验室1",
            "skrq": "2019-05-20",
            "time": "16:30",
            "xq": 0,
            "xqj": ""
          }
        }
      }
    },
    computed: {},
    watch: {},
    methods: {
      getHeightSum() {
        let sum = 0
        this.heiList.forEach((item) => {
          sum = sum + item
        })
        return sum
      },
      initScroll() {
        let infoWrapper = this.$refs.infoWrapper
        let infoList = infoWrapper.getElementsByTagName('div')
        this.heiList.push(0)
        for (let i = 0; i < infoList.length - 1; i++) {
          this.heiList.push(this.getHeightSum() + infoList[i].offsetHeight)
        }
      },
      setTransform() {
        setInterval(() => {
          console.log(this.$refs.infoWrapper)
          this.currShowIdx++
          if (this.currShowIdx >= this.heiList.length) {
            this.currShowIdx = 0
          }
          this.$refs.infoWrapper.style.transform = `translateY(${-this.heiList[this.currShowIdx]}px)`
        }, SCROLL_DURING)
      }
    },
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
      this.$nextTick(() => {
        this.initScroll()
        this.setTransform()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .smallScroll


    .wrapper
      width 100%
      transition 300ms

      & > div
        padding-top 5px
        line-height 1.5
        font-size 16px
        height 100px
        width 100%

</style>


// WEBPACK FOOTER //
// src/components/course/smallScroll.vue